import * as actionTypes from '../actionTypes/Whiteboard'

export const setWhiteboardSize = isWhiteboardFullSize => {
    return {
        type: actionTypes.SET_WHITEBOARD_SIZE,
        isWhiteboardFullSize,
    }
}

export const setWhiteboarUrl = whiteboardUrl => {
    return {
        type: actionTypes.SET_WHITEBOARD_URL,
        whiteboardUrl,
    }
}

export const setPreviousWhiteboard = previousWhiteboard => {
    return {
        type: actionTypes.SET_PREVIOUS_WHITEBOARD,
        previousWhiteboard,
    }
}
